// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoaderData_page__data__rYlck {
	width: 100%;
	display: flex;
	justify-content: center;
	gap: 2rem;
}

.LoaderData_data__title__SJ31k {
	color: var(--accent-color, #875b52);
	/* H3 */
	font-family: 'Noto Sans';
	font-size: 1.625rem;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 2.4375rem */
}

.LoaderData_data__block__ChGXf {
	display: flex;
	flex-direction: column;
	gap: 1.9rem;
}

.LoaderData_reservation__data__DJQWn {
	width: 33.75rem;
	height: 47.125rem;
	border-radius: 0.5rem;
	border: 1px solid var(--accent-color, #875b52);
	background: var(--gray-color, #fff9f8);

	padding: 3.13rem 4.1rem;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.LoaderData_reservation__data__block__8qV6Y {
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
}

.LoaderData_reservation__data__block__title__8SpXO {
	display: flex;
	gap: 0.6rem;
	color: var(--accent-color, #875b52);
	/* text small */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */
}
.LoaderData_reservation__data__block__text__b5l4C {
	color: var(--accent-color, #875b52);
	/* H3 */
	font-family: 'Noto Sans';
	font-size: 1.625rem;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 2.4375rem */
}

.LoaderData_reservation__data__block__info__SW\\+R3 {
	width: 100%;
	display: flex;
	justify-content: space-between;

	color: var(--accent-color, #875b52);
	/* text small bold */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 700;
	line-height: 160%; /* 1.6rem */
}

.LoaderData_reservation__data__result__wnJ9b {
	border-top: 1px solid var(--accent-color);
	padding: 0.31rem 0;
	width: 100%;
	display: flex;
	justify-content: space-between;
}

.LoaderData_reservation__data__result__wnJ9b span {
	color: var(--accent-color, #875b52);
	font-size: 1.625rem;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 2.4375rem */
}

@media (max-width: 460px) {
	.LoaderData_page__data__rYlck {
		flex-direction: column;
	}

	.LoaderData_reservation__data__DJQWn {
		width: 100%;
		height: auto;
		padding: 1.5rem;
		gap: 3rem;
	}
	.LoaderData_reservation__data__block__text__b5l4C {
		font-size: 1.3rem;
		font-style: normal;
		font-weight: 500;
		line-height: 130%;
	}

	.LoaderData_reservation__data__block__info__SW\\+R3:nth-child(2) {
		text-align: right;
	}
}
`, "",{"version":3,"sources":["webpack://./src/Components/ReservationPage/LoaderData/LoaderData.module.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,SAAS;AACV;;AAEA;CACC,mCAAmC;CACnC,OAAO;CACP,wBAAwB;CACxB,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,cAAc;AAClC;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,qBAAqB;CACrB,8CAA8C;CAC9C,sCAAsC;;CAEtC,uBAAuB;CACvB,aAAa;CACb,sBAAsB;CACtB,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,aAAa;CACb,WAAW;CACX,mCAAmC;CACnC,eAAe;CACf,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;AACA;CACC,mCAAmC;CACnC,OAAO;CACP,wBAAwB;CACxB,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,cAAc;AAClC;;AAEA;CACC,WAAW;CACX,aAAa;CACb,8BAA8B;;CAE9B,mCAAmC;CACnC,oBAAoB;CACpB,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,yCAAyC;CACzC,kBAAkB;CAClB,WAAW;CACX,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,mCAAmC;CACnC,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,cAAc;AAClC;;AAEA;CACC;EACC,sBAAsB;CACvB;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;CACV;CACA;EACC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;CAClB;;CAEA;EACC,iBAAiB;CAClB;AACD","sourcesContent":[".page__data {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\tgap: 2rem;\n}\n\n.data__title {\n\tcolor: var(--accent-color, #875b52);\n\t/* H3 */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1.625rem;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 150%; /* 2.4375rem */\n}\n\n.data__block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 1.9rem;\n}\n\n.reservation__data {\n\twidth: 33.75rem;\n\theight: 47.125rem;\n\tborder-radius: 0.5rem;\n\tborder: 1px solid var(--accent-color, #875b52);\n\tbackground: var(--gray-color, #fff9f8);\n\n\tpadding: 3.13rem 4.1rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n}\n\n.reservation__data__block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.25rem;\n}\n\n.reservation__data__block__title {\n\tdisplay: flex;\n\tgap: 0.6rem;\n\tcolor: var(--accent-color, #875b52);\n\t/* text small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n}\n.reservation__data__block__text {\n\tcolor: var(--accent-color, #875b52);\n\t/* H3 */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1.625rem;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 150%; /* 2.4375rem */\n}\n\n.reservation__data__block__info {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\tcolor: var(--accent-color, #875b52);\n\t/* text small bold */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 160%; /* 1.6rem */\n}\n\n.reservation__data__result {\n\tborder-top: 1px solid var(--accent-color);\n\tpadding: 0.31rem 0;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.reservation__data__result span {\n\tcolor: var(--accent-color, #875b52);\n\tfont-size: 1.625rem;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 150%; /* 2.4375rem */\n}\n\n@media (max-width: 460px) {\n\t.page__data {\n\t\tflex-direction: column;\n\t}\n\n\t.reservation__data {\n\t\twidth: 100%;\n\t\theight: auto;\n\t\tpadding: 1.5rem;\n\t\tgap: 3rem;\n\t}\n\t.reservation__data__block__text {\n\t\tfont-size: 1.3rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 130%;\n\t}\n\n\t.reservation__data__block__info:nth-child(2) {\n\t\ttext-align: right;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page__data": `LoaderData_page__data__rYlck`,
	"data__title": `LoaderData_data__title__SJ31k`,
	"data__block": `LoaderData_data__block__ChGXf`,
	"reservation__data": `LoaderData_reservation__data__DJQWn`,
	"reservation__data__block": `LoaderData_reservation__data__block__8qV6Y`,
	"reservation__data__block__title": `LoaderData_reservation__data__block__title__8SpXO`,
	"reservation__data__block__text": `LoaderData_reservation__data__block__text__b5l4C`,
	"reservation__data__block__info": `LoaderData_reservation__data__block__info__SW+R3`,
	"reservation__data__result": `LoaderData_reservation__data__result__wnJ9b`
};
export default ___CSS_LOADER_EXPORT___;
